<template>
  <div v-loading="loading" class="base-info__container base-flex">
    <div class="base-info__left">
      <h3>{{ $t('customCluster.baseInfo.basicInfo') }}</h3>
      <div class="base-margin__bottom-20"><span>{{ $t('customCluster.baseInfo.clusterName') }}</span><span>{{
          info.Name
        }}</span></div>
      <div class="base-margin__bottom-20"><span>{{ $t('customCluster.baseInfo.clusterId') }}</span><span>{{
          info.Id
        }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('customCluster.baseInfo.region')
        }}</span><span>{{ info.Region }}</span></div>
      <div class="base-margin__bottom-20"><span>{{ $t('customCluster.baseInfo.zone') }}</span><span>{{
          info.Zone
        }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('customCluster.baseInfo.instanceCount')
        }}</span><span>{{ info.InstanceCount }}</span></div>
      <!--<div class="base-margin__bottom-20">-->
      <!--  <span>{{ $t('customCluster.baseInfo.imageId') }}</span>-->
      <!--  <span class="base-color__light_blue base-cursor__pointer"-->
      <!--        @click="open('img', info.imageId)">{{ info.imageId }}</span>-->
      <!--</div>-->
      <!--<div class="base-margin__bottom-20"><span>{{-->
      <!--    $t('customCluster.baseInfo.instanceType')-->
      <!--  }}</span>-->
      <!--  <span>{{ info.instanceType }}</span>-->
      <!--</div>-->
      <!--<div class="base-margin__bottom-20"><span>{{-->
      <!--    $t('customCluster.baseInfo.diskType')-->
      <!--  }}</span><span>{{ filterDiskType(info.diskType) }}</span>-->
      <!--</div>-->
      <!--<div class="base-margin__bottom-20"><span>{{ $t('customCluster.baseInfo.diskSize') }}</span><span>{{-->
      <!--    info.diskSize-->
      <!--  }} GB</span></div>-->
      <div class="base-margin__bottom-20">
        <span>{{ $t('customCluster.baseInfo.hostnameIp') }}</span>
        <span class="base-color__light_blue base-cursor__pointer"
              @click="preview(info)">{{ $t('customCluster.baseInfo.preview') }}</span>
      </div>
      <!--<div class="base-margin__bottom-20"><span>{{-->
      <!--    $t('customCluster.baseInfo.hyperThreading')-->
      <!--  }}</span><span>{{-->
      <!--    info.hyperTreading ? $t('customCluster.baseInfo.enabled') : $t('customCluster.baseInfo.disabled')-->
      <!--  }}</span>-->
      <!--</div>-->
      <!--<div class="base-margin__bottom-20">-->
      <!--  <span>{{-->
      <!--      $t('customCluster.baseInfo.chargeType')-->
      <!--    }}</span><span>{{-->
      <!--    info.instanceChargeType === 'PREPAID' ? $t('customCluster.baseInfo.prepaid') : $t('customCluster.baseInfo.postpaid')-->
      <!--  }}</span></div>-->
      <!--<div v-if="info.instanceChargeType === 'PREPAID'">-->
      <!--  <div class="base-margin__bottom-20"><span>{{-->
      <!--      $t('customCluster.baseInfo.prepaidPeriod')-->
      <!--    }}</span><span>{{ info.instanceChargePrepaidPeriod }} {{ $t('customCluster.baseInfo.months') }}</span>-->
      <!--  </div>-->
      <!--  <div class="base-margin__bottom-20"><span>{{ $t('customCluster.baseInfo.autoRenew') }}</span><span>{{-->
      <!--      info.instanceChargePrepaidRenewFlag === 'NOTIFY_AND_MANUAL_RENEW' ? $t('customCluster.baseInfo.no') : $t('customCluster.baseInfo.yes')-->
      <!--    }}</span></div>-->
      <!--</div>-->
      <el-button
        type="primary"
        @click="showAddInstanceDialog"
        v-if="disabledAddInstance"
      >{{ $t('customCluster.baseInfo.addInstance') }}
      </el-button>
    </div>
    <div class="base-info__right">
      <h3>{{ $t('customCluster.baseInfo.networkInfo') }}</h3>
      <div class="base-margin__bottom-20">
        <span>{{ $t('customCluster.baseInfo.vpc') }}</span>
        <span class="base-color__light_blue base-cursor__pointer"
              @click="open('vpc', info.vpcId)">{{ info.VpcId }}</span>
        <!--<span>{{-->
        <!--    !info.vpcName || !info.vpcCidr ? $t('customCluster.baseInfo.resourceNotExist') : `(${info.vpcName} | ${info.vpcCidr})`-->
        <!--  }}</span>-->
      </div>
      <div class="base-margin__bottom-20">
        <span>{{ $t('customCluster.baseInfo.subnet') }}</span>
        <span class="base-color__light_blue base-cursor__pointer"
              @click="open('subnet', info.subnetId)">{{ info.SubnetId }}</span>
        <!--<span>{{-->
        <!--    !info.subnetName || !info.subnetCidr ? $t('customCluster.baseInfo.resourceNotExist') : `(${info.subnetName} | ${info.subnetCidr})`-->
        <!--  }}</span>-->
      </div>
      <div class="base-margin__bottom-20 base-flex">
        <span>{{ $t('customCluster.baseInfo.securityGroup') }}</span>
        <div>
          <div v-for="item in info.SecurityGroupIds" :key="item">
            <p class="base-color__light_blue base-cursor__pointer" @click="open('sg', item)">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <!--<div class="base-margin__bottom-20">-->
      <!--  <span>{{ $t('customCluster.baseInfo.startIp') }}</span>-->
      <!--  <span>{{ info.startIp }}</span>-->
      <!--</div>-->
      <!--<div class="base-margin__bottom-20">-->
      <!--  <span>{{ $t('customCluster.baseInfo.endIp') }}</span>-->
      <!--  <span>{{ info.endIp }}</span>-->
      <!--</div>-->
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.baseInfo.previewIp')"
      :visible.sync="previewDialogVisible"
      append-to-body
      class="draggableDialog"
      width="600px"
      @opened="defaultRowDrop">
      <div class="previewDialog_main--div draggable">
        <el-table
          :data="previewList"
          border
          class="base-width_fullscreen"
          max-height="400"
          row-key="ip"
        >
          <el-table-column
            v-for="(item,index) in oldList"
            :key="`col_${index}`"
            :label="item.label"
            :prop="newList[index].prop"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <p class="base-margin__top-10">{{ $t('customCluster.baseInfo.previewTip') }}</p>
      <span slot="footer" class="dialog-footer">
         <el-button class="exportPreviewCls" @click="copyPreviewIp">{{ $t('customCluster.baseInfo.copy') }}</el-button>
         <el-button class="exportPreviewCls" type="primary"
                    @click="exportPreviewIp(previewList)">{{ $t('customCluster.baseInfo.export') }}</el-button>
       </span>
    </el-dialog>


    <!--新增实例 弹窗-->
    <addInstanceDialog ref="addInstanceDialog"/>
  </div>
</template>


<script>
import {postRequest} from '@/common/libs/request';
import {exportData, filterDiskType} from '@/common/utils/utils';
import Sortable from 'sortablejs';
import {UTIL} from '@/common/utils';
import addInstanceDialog from '../addInstance';

export default {
  name: 'baseInfo',
  components: {
    addInstanceDialog
  },
  data() {
    return {
      filterDiskType,
      info: {},
      loading: true,
      previewDialogVisible: false,
      previewList: [],
      oldList: [],
      newList: [],
      tableConfig: {
        tableItems: [
          {
            label: 'hostname',
            prop: 'hostname',
          },
          {
            label: 'ip',
            prop: 'ip',
          },
        ],
      },
      multicloudWhiteList: sessionStorage.getItem('multicloudWhiteList')?.split(',') || [],
      userId: sessionStorage.getItem('userId').toString(),
      disabledAddInstance: !(sessionStorage.getItem('multicloudWhiteList')?.split(',') || []).includes(sessionStorage.getItem('userId')?.toString() || ''),
    };
  },
  computed: {
  },
  mounted() {
    this.getSubclusterDetail();
    this.disabledAddInstance = this.multicloudWhiteList.includes(this.userId);
  },
  methods: {
    showAddInstanceDialog() {
      this.$refs.addInstanceDialog.dialogVisible = true;
    },

    // 导出预览IP
    exportPreviewIp(item) {
      const result = item.map(item => ({
        HostName: item.hostname,
        IP: item.ip,
      }));
      exportData(result, this.$t('customCluster.baseInfo.previewIp'));
    },

    preview() {
      this.previewDialogVisible = true;
    },
    getSubclusterDetail() {
      const params = {
        filters: [{ name: 'id', values: [this.$route.query.id] }],
        offset: 0,
        limit: 1000
      };
      postRequest('/api/eda/common/multicloud/describeMultiCloudPartitionList', params).then((res) => {
        this.info = res.partitionList[0];
        this.previewList = res.partitionList[0].RelationList;
        this.loading = false;
      });
    },

    defaultRowDrop() {
      this.oldList = JSON.parse(JSON.stringify(this.tableConfig.tableItems));
      this.newList = JSON.parse(JSON.stringify(this.tableConfig.tableItems));
      this.columnDrop();
      // this.rowDrop();
    },

    // 列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector('.draggableDialog .draggable .el-table__header-wrapper tr');
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: (evt) => {
          const oldItem = this.newList[evt.oldIndex];
          this.newList.splice(evt.oldIndex, 1);
          this.newList.splice(evt.newIndex, 0, oldItem);
        },
      });
    },

    copyPreviewIp() {
      const result = this.parseHosts(this.previewList, this.newList);
      UTIL.copyText(this, result);
    },

    // 解析函数
    parseHosts(hosts, format) {
      return hosts.map(host => format.map(item => host[item.prop]).join(' '), // 按照 format 中的顺序拼接字符串
      ).join('\n');
    },

    open(type, val) {
      console.log(type, val);
      // switch (type) {
      //   case 'vpc':
      //     window.open(`https://console.cloud.tencent.com/vpc/vpc/detail?rid=${regionMap.get(this.info.region)}&id=${val}`);
      //     break;
      //   case 'subnet':
      //     window.open(`https://console.cloud.tencent.com/vpc/subnet/detail?rid=${regionMap.get(this.info.region)}&id=${val}`);
      //     break;
      //   case 'sg':
      //     window.open(`https://console.cloud.tencent.com/vpc/security-group/detail/${val}?rid=${regionMap.get(this.info.region)}`);
      //     break;
      //   case 'img':
      //     window.open(`https://console.cloud.tencent.com/cvm/image/detail?rid=${regionMap.get(this.info.region)}&id=${val}`);
      //     break;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.previewDialog_main--div {
  max-height: 400px;
}

.base-info__container {
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 10px 20px 30px;

  span:first-child {
    display: inline-block;
    width: 140px;
    margin-right: 20px;
  }
}

.base-info__left, .base-info__right {
  width: 50%;

  h3 {
    margin-bottom: 30px;
  }
}

.exportPreviewCls {
  padding: 12px 20px;
}
</style>
